var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160-200h80v-320h480v320h80v-426L480-754 160-626v426zm-80 80v-560l400-160 400 160v560H640v-320H320v320H80zm280 0v-80h80v80h-80zm80-120v-80h80v80h-80zm80 120v-80h80v80h-80zM240-520h480-480z"
  })));
}
export default Svg24Px;